/**
 * Helpers partagés autour des rôles d'une commune.
 *
 * Un rôle porte deux noms : `name` est le slug technique dérivé du libellé
 * côté serveur, `label` est ce que la commune a saisi. `is_system` signale
 * seulement qu'il s'agit de la copie d'un modèle plateforme — ce n'est pas une
 * protection : la commune peut renommer et supprimer ces rôles comme les
 * autres. On s'en sert uniquement pour retrouver le libellé traduit d'un rôle
 * historique (Administrateur, Manager, Agent, Lecteur…).
 */
export function getRoleSlug(role) {
    if (!role) return ''
    if (typeof role !== 'object') return String(role)
    return role.name || ''
}

export function isTemplateRole(role) {
    return !!(role && typeof role === 'object' && role.is_system)
}

function translated(i18n, key) {
    const value = i18n.t(key)
    return value === key ? '' : value
}

/**
 * Libellé affiché : traduction d'un rôle modèle quand elle existe, libellé
 * saisi par la commune sinon. Un rôle modèle renommé voit son slug changer,
 * donc la traduction ne s'applique plus et son nouveau libellé l'emporte.
 */
export function roleDisplayName(i18n, role) {
    const slug = getRoleSlug(role)
    const isTemplate = typeof role !== 'object' || isTemplateRole(role)
    if (slug && isTemplate) {
        const label = translated(i18n, `companies.user.roles.${slug}`)
        if (label) return label
    }
    if (role && typeof role === 'object' && role.label) return role.label
    return slug
}

export function roleDisplayDescription(i18n, role) {
    if (role && typeof role === 'object' && role.description) return role.description
    const slug = getRoleSlug(role)
    const isTemplate = typeof role !== 'object' || isTemplateRole(role)
    if (!slug || !isTemplate) return ''
    return translated(i18n, `companies.user.roles.${slug}_desc`)
}

export function rolePermissions(role) {
    if (!role || !Array.isArray(role.permissions)) return []
    return role.permissions.map((permission) =>
        permission && typeof permission === 'object' ? permission.name : permission
    )
}

export function roleUsersCount(role) {
    if (!role) return null
    const count = role.users_count !== undefined ? role.users_count : role.usersCount
    return typeof count === 'number' ? count : null
}
